import querystring from 'query-string';

import { ZINES_API_ENDPOINT, EDITOR_API_FEVER_HOST } from 'config/envVariable';
import { GET, POST, PATCH, normalizeResponse } from 'api/common';
import { getFirebaseIdToken } from 'editor/utils/firebaseManager';

async function fetchZines(path, optionsPromise) {
    const options = await optionsPromise;
    return fetch(`${ZINES_API_ENDPOINT}${path}`, options).then(normalizeResponse);
}
async function fetchZinesServer(path, optionsPromise) {
    const options = await optionsPromise;
    return fetch(`https://${EDITOR_API_FEVER_HOST}${path}`, options).then(normalizeResponse);
}

async function generateZinesApiFetchOpts({
    method = GET,
    headers = {},
    body = null,
    ...rest
} = {}) {
    return {
        method,
        headers: new Headers({
            'Content-Type': 'application/json; charset=utf-8',
            Authorization: `Bearer ${await getFirebaseIdToken()}`,
            ...headers
        }),
        body: body && JSON.stringify(body),
        ...rest
    };
}

export function bindPromoToZinesPage({ sponsorId, promoUUID, pageId }) {
    return fetchZines(
        `/sponsors/${sponsorId}/newPromoPage/${pageId}?host=${EDITOR_API_FEVER_HOST}`,
        generateZinesApiFetchOpts({
            method: POST,
            body: { promotion_uuid: promoUUID },
            redirect: 'follow'
        })
    ).then(resp => {
        if (resp.httpStatus !== 200) {
            throw resp;
        }
        return resp.payload;
    });
}

export function getZinesPageInfo(sponsorId, pageId) {
    const qs = querystring.stringify({
        _limit: 1,
        _page: 1,
        _keyword: pageId,
        _label: '',
        _pageId: '',
        host: EDITOR_API_FEVER_HOST
    });
    return fetchZines(`/sponsors/${sponsorId}/pages?${qs}`, generateZinesApiFetchOpts())
        .then(resp => {
            if (resp.httpStatus !== 200) {
                throw resp;
            }
            return (resp.payload || {}).data;
        })
        .then(([{ isHome = 0, publish = false } = {}] = []) => ({
            pageId,
            isHomePage: Boolean(isHome),
            isPublished: publish
        }));
}

export function publishZinesPage(pageId, publish = true) {
    return fetchZines(
        `/page/${pageId}/publishing?host=${EDITOR_API_FEVER_HOST}`,
        generateZinesApiFetchOpts({
            method: PATCH,
            body: { publish }
        })
    ).then(resp => {
        if (resp.httpStatus !== 200) {
            throw resp;
        }
        return true;
    });
}

export function setZinesPageMeta(pageId, { title, description }) {
    return fetchZines(
        `/page/${pageId}/meta?host=${EDITOR_API_FEVER_HOST}`,
        generateZinesApiFetchOpts({
            method: PATCH,
            body: { title, description, image: '', urlTitle: '' }
        })
    ).then(resp => {
        if (resp.httpStatus !== 200) {
            throw resp;
        }
        return true;
    });
}

export function clearZinesPageCache({ sponsorId, pageId, feDomain, beDomain, uniqueName }) {
    return fetchZinesServer(
        `/zapi/sponsors/${sponsorId}/pages/${pageId}/cache/clear`,
        generateZinesApiFetchOpts({ method: POST, body: { feDomain, beDomain, uniqueName } })
    ).then(resp => {
        if (resp.httpStatus !== 200) {
            console.log('Failed to clear zines page cache:', resp.payload);
            return false;
        }
        return true;
    });
}
